import Default from "./ActionTemplateParametersList";
export * from "./ActionTemplateParametersList";

export default Default;
